import { render } from "./FavoriteMovies.vue?vue&type=template&id=ca8e63dc&scoped=true"
import script from "./FavoriteMovies.vue?vue&type=script&lang=js"
export * from "./FavoriteMovies.vue?vue&type=script&lang=js"

import "./FavoriteMovies.vue?vue&type=style&index=0&id=ca8e63dc&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca8e63dc"]])

export default __exports__